/**
 * Joins firstName and lastName into a full name string.
 * Inverse of splitFullName.
 *
 * @returns The joined name, or undefined if both parts are falsy.
 */
export function joinFullName(
  firstName?: string | null,
  lastName?: string | null
): string | undefined {
  const full = [firstName, lastName].filter(Boolean).join(' ');
  return full || undefined;
}
